angular.module('myApp')

.factory('commonFactory', [
  '$routeParams', '$sessionStorage', '$timeout', 'Const',
  function ($routeParams, $sessionStorage, $timeout, Const) {
    this.fullSetList = ['abcdefghijklmnopqrstuvwxyz',
                    'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                    '0123456789',
                    '^$*.[]{}()?-“!@#%&/,><‘:;|_~`'];
    this.lowercaseAlphabetList = ['abcdefghijklmnopqrstuvwxyz'];
    this.numberList = ['0123456789'];
    /**
     * 指定されたフラッシュメッセージ用のフラグを指定ミリ秒の間だけtrueにする。
     */
    this.flashErrorMessageFlag = (flagName, msec, transitToLoginBool) => {
      $sessionStorage[flagName] = true;
      $timeout(() => {
        $sessionStorage[flagName] = false;
        if (transitToLoginBool) {
          if (localStorage.getItem(Const.LSAPP_ROLE) === Const.LSAPP_ROLE_MEMBER) {
            location.href = '#/member/login';
          } else {
            location.href = '#/staff/login';
          }
        }
      }, msec);
    };

    /*
       渡された Date の月初日と月末日を返します。
       ex)
       beginDateParam : Thu Jan 01 2016 00:00:00 GMT+0900 (JST)
       endDateParam   : Fri Feb 01 2016 00:00:00 GMT+0900 (JST)
     */
    this.getMonthRange = date => {
      let beginDateParam = new Date(date.getFullYear(), date.getMonth());
      let endDateParam = new Date(date.getFullYear(), date.getMonth() + 1);
      return {
        endDateParam: endDateParam.toISOString(),
        beginDateParam: beginDateParam.toISOString()
      };
    };

    this.getThreeMonthsBeforeAndAfter = date => {
      let beginDateParam = new Date(date.getFullYear(), date.getMonth() - 3);
      let endDateParam = new Date(date.getFullYear(), date.getMonth() + 3);
      return {
        endDateParam: endDateParam.toISOString(),
        beginDateParam: beginDateParam.toISOString()
      };
    };

    /*
       渡された Date からひと月先を返す
    */
    this.getMonthLater = date => {
      let beginDateParam = new Date(date.getFullYear(), date.getMonth() + 1);
      let endDateParam = new Date(date.getFullYear(), date.getMonth() + 2);
      return {
        endDateParam: endDateParam.toISOString(),
        beginDateParam: beginDateParam.toISOString()
      };
    };

    /*
       渡された Date からひと月前に戻す
    */
    this.getMonthAgo = date => {
      let beginDateParam = new Date(date.getFullYear(), date.getMonth() - 1);
      let endDateParam = new Date(date.getFullYear(), date.getMonth());
      return {
        endDateParam: endDateParam.toISOString(),
        beginDateParam: beginDateParam.toISOString()
      };
    };

    /*
       アルファベット小文字4文字、数字4桁のパスワードを生成
    */
    this.createImterimPassword = () => {
      let lowercase = this.generatePassword(4, this.lowercaseAlphabetList);
      let number = this.generatePassword(4, this.numberList);
      return lowercase + number;
    };

    /*
       ポリシーに準拠したパスワードを自動生成
       第一引数が数値ではない、または4より小さいの場合は、4文字のパスワードが返却される
       第二引数であるリスト内から最低一文字以上採用して、ポリシーに準拠させる

       [
        "abcdefghijklmnopqrstuvwxyz",
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        "0123456789"
       ]

       上記の場合、半角英字(大文字/小文字)、半角数字の中から一文字以上採用して、
       パスワードを作成する
       記号をポリシーに含めたい場合、"=~|{}_?+*`@`"などを配列に含めれば良い

       返却値の例:
         commonFactory.generatePassword(3) => hI94hDQG
         commonFactory.generatePassword(4) => n4vZQbfn
         commonFactory.generatePassword(5) => Vaq7M
         commonFactory.generatePassword('5') => z70y69Fl
         commonFactory.generatePassword(8) => GN47RQat
         commonFactory.generatePassword('w') => 3qYmC9SC
         commonFactory.generatePassword('0012') => vQ0k0ZVy
     */
    this.generatePassword = (count, list) => {
      if (!Number.isFinite(count) || count < 4) { count = 4; }
      let c = xs => xs[Math.floor(Math.random() * xs.length)];
      let f = (n, ws) => {
        let i = ws.length;
        let l = ws.length;
        let w = [];
        let r = [];

        for (i = 0; i < l; i++) {
          r.push(c(ws[i]));
        }
        w = String.prototype.concat.apply('', ws);
        for (; i < n; i++) {
          r.push(c(w));
        }
        for (; i >= 0; i--) {
          let j = Math.floor(Math.random() * n);
          let t = r[i];
          r[i] = r[j];
          r[j] = t;
        }
        return r.join('');
      };
      return f(count, list);
    };

    /*
       渡された数値を、渡された桁数になるまで0埋め(左埋め)した値を返却する。
       第一引数、第二引数ともが数値ではない場合、第一引数をそのまま返却する。
       第二引数が21桁以上の場合も、第一引数をそのまま返却する。
     */
    this.getPaddingZero = (num, count) => {
      let maxLength = 21;
      if (!num) { num = 0; }
      if (!Number.isFinite(parseInt(num)) || !Number.isFinite(count)) { return num; }
      if (count >= maxLength) { return num; }
      return ('00000000000000000000' + num).slice(count * -1);
    };

    /*
       渡された数値を、渡された桁数になるまで0埋め(左埋め)した値を返却する。
       第一引数、第二引数ともが数値ではない場合、第一引数をそのまま返却する。
       第二引数が21桁以上の場合も、第一引数をそのまま返却する。
     */
    this.getGenderName = genderNum => {
      if (!Number.isFinite(genderNum)) { return genderNum; }
      let genderName;
      switch (genderNum) {
        case Const.GENDER_TYPE.male:
          genderName = '男';
          break;
        case Const.GENDER_TYPE.female:
          genderName = '女';
          break;
        default:
          genderName = '-';
      }
      return genderName;
    };

    // Local Storageに保存したものを削除する
    this.deleteLocalStorage = () => {
      if (localStorage.getItem(Const.LSKEY_USER_ID)) {
        localStorage.removeItem(Const.LSKEY_USER_ID);
      }
      if (localStorage.getItem(Const.LSKEY_USER_ID_TOKEN)) {
        localStorage.removeItem(Const.LSKEY_USER_ID_TOKEN);
      }
      if (localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID)) {
        localStorage.removeItem(Const.LSKEY_USER_ACCESS_KEY_ID);
      }
      if (localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY)) {
        localStorage.removeItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
      }
      if (localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN)) {
        localStorage.removeItem(Const.LSKEY_USER_SESSION_TOKEN);
      }
      if (localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN)) {
        localStorage.removeItem(Const.LSKEY_USER_REFRESH_TOKEN);
      }
      if (localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN)) {
        localStorage.removeItem(Const.LSKEY_USER_ACCESS_TOKEN);
      }
      if (localStorage.getItem(Const.LSAPP_SCHOOL_NAME)) {
        localStorage.removeItem(Const.LSAPP_SCHOOL_NAME);
      }
      if (localStorage.getItem(Const.LSAPP_SCHOOL_ID)) {
        localStorage.removeItem(Const.LSAPP_SCHOOL_ID);
      }
      if (localStorage.getItem(Const.LSAPP_MEMBER_NAME)) {
        localStorage.removeItem(Const.LSAPP_MEMBER_NAME);
      }
      if (localStorage.getItem(Const.LSAPP_MEMBER_ID)) {
        localStorage.removeItem(Const.LSAPP_MEMBER_ID);
      }
      if (localStorage.getItem(Const.LSAPP_DISP_MEMBER_ID)) {
        localStorage.removeItem(Const.LSAPP_DISP_MEMBER_ID);
      }
      if (localStorage.getItem(Const.LSAPP_ROLE)) {
        localStorage.removeItem(Const.LSAPP_ROLE);
      }

      // Cognitoに関するlocalStorageを削除
      for (let key in localStorage) {
        if (/CognitoIdentityServiceProvider/.test(key) ||
            /aws.cognito/.test(key)) {
          localStorage.removeItem(key);
        }
      }
    };

    // Session Storageに保存したものを削除する
    this.deleteSessionStorage = () => {
      if ($sessionStorage[Const.LSAPP_ROLE]) {
        delete $sessionStorage[Const.LSAPP_ROLE];
      }
      if ($sessionStorage[Const.SSAPP_SCHOOL_NAME]) {
        delete $sessionStorage[Const.SSAPP_SCHOOL_NAME];
      }
      if ($sessionStorage[Const.SSAPP_COACH_NAME]) {
        delete $sessionStorage[Const.SSAPP_COACH_NAME];
      }
      if ($sessionStorage[Const.SSAPP_COACH_GENDER] !== null) {
        delete $sessionStorage[Const.SSAPP_COACH_GENDER];
      }
      if ($sessionStorage[Const.SSAPP_USER_NAME]) {
        delete $sessionStorage[Const.SSAPP_USER_NAME];
      }
      if ($sessionStorage[Const.SSAPP_GENDER] !== null) {
        delete $sessionStorage[Const.SSAPP_GENDER];
      }
      if ($sessionStorage[Const.SSAPP_COMPANY_ID]) {
        delete $sessionStorage[Const.SSAPP_COMPANY_ID];
      }
      if ($sessionStorage[Const.SSAPP_SCHOOL_ID]) {
        delete $sessionStorage[Const.SSAPP_SCHOOL_ID];
      }
      if ($sessionStorage[Const.SSAPP_COURSE_ID]) {
        delete $sessionStorage[Const.SSAPP_COURSE_ID];
      }
      if ($sessionStorage[Const.SSAPP_MEMBER_ID]) {
        delete $sessionStorage[Const.SSAPP_MEMBER_ID];
      }
      if ($sessionStorage[Const.SSAPP_SELECTED_YEAR_MONTH]) {
        delete $sessionStorage[Const.SSAPP_SELECTED_YEAR_MONTH];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_BEGIN_DATE]) {
        delete $sessionStorage[Const.SSAPP_LESSON_BEGIN_DATE];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_END_DATE]) {
        delete $sessionStorage[Const.SSAPP_LESSON_END_DATE];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_NAME]) {
        delete $sessionStorage[Const.SSAPP_LESSON_NAME];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_DATE]) {
        delete $sessionStorage[Const.SSAPP_LESSON_DATE];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_DAY]) {
        delete $sessionStorage[Const.SSAPP_LESSON_DAY];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_BEGIN_TIME]) {
        delete $sessionStorage[Const.SSAPP_LESSON_BEGIN_TIME];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_END_TIME]) {
        delete $sessionStorage[Const.SSAPP_LESSON_END_TIME];
      }
      if ($sessionStorage[Const.SSAPP_DISP_LESSON_INDEX] !== null) {
        delete $sessionStorage[Const.SSAPP_DISP_LESSON_INDEX];
      }
      if ($sessionStorage[Const.SSAPP_DISP_LESSON_LIST]) {
        delete $sessionStorage[Const.SSAPP_DISP_LESSON_LIST];
      }
      if ($sessionStorage[Const.SSAPP_TARGET_LESSON_INDEX] !== null) {
        delete $sessionStorage[Const.SSAPP_TARGET_LESSON_INDEX];
      }
      if ($sessionStorage[Const.SSAPP_TARGET_LESSON_LIST]) {
        delete $sessionStorage[Const.SSAPP_TARGET_LESSON_LIST];
      }
      if ($sessionStorage[Const.SSAPP_COURSE_INDEX] !== null) {
        delete $sessionStorage[Const.SSAPP_COURSE_INDEX];
      }
      if ($sessionStorage[Const.SSAPP_COURSE_LIST]) {
        delete $sessionStorage[Const.SSAPP_COURSE_LIST];
      }
      if ($sessionStorage[Const.SSAPP_SENSOR_RENTAL] !== null) {
        delete $sessionStorage[Const.SSAPP_SENSOR_RENTAL];
      }
      if ($sessionStorage[Const.SSAPP_EULA_AGREE] !== null) {
        delete $sessionStorage[Const.SSAPP_EULA_AGREE];
      }
      if ($sessionStorage[Const.SSAPP_SMALL_HEIGHT]) {
        delete $sessionStorage[Const.SSAPP_SMALL_HEIGHT];
      }
      if ($sessionStorage[Const.SSAPP_IS_LOADING] !== null) {
        delete $sessionStorage[Const.SSAPP_IS_LOADING];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_COACH_NAME] !== null) {
        delete $sessionStorage[Const.SSAPP_LESSON_COACH_NAME];
      }
      if ($sessionStorage[Const.SSAPP_LESSON_SUB_COACH_NAME] !== null) {
        delete $sessionStorage[Const.SSAPP_LESSON_SUB_COACH_NAME];
      }
      if ($sessionStorage[Const.SSAPP_HEATMAP_FLG] !== null) {
        delete $sessionStorage[Const.SSAPP_HEATMAP_FLG];
      }
      if ($sessionStorage[Const.SSAPP_SHOT_KIND] !== null) {
        delete $sessionStorage[Const.SSAPP_SHOT_KIND];
      }
      if ($sessionStorage[Const.SSAPP_RENDER_FIN] !== null) {
        delete $sessionStorage[Const.SSAPP_RENDER_FIN];
      }
      if ($sessionStorage[Const.SSAPP_SELECTED_DATE] !== null) {
        delete $sessionStorage[Const.SSAPP_SELECTED_DATE];
      }
      if ($sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE] !== null) {
        delete $sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE];
      }
      if ($sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE] !== null) {
        delete $sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE];
      }
      if ($sessionStorage[Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] !== null) {
        delete $sessionStorage[Const.SSAPP_ADMIN_COURSE_LIST_LOCATION];
      }
      if ($sessionStorage[Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER] !== null) {
        delete $sessionStorage[Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER];
      }
      if ($sessionStorage[Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] !== null) {
        delete $sessionStorage[Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER];
      }
      if ($sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE] !== null) {
        delete $sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE];
      }
      if ($sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE] !== null) {
        delete $sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE];
      }
      if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE] !== null) {
        delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE];
      }
      if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE] !== null) {
        delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE];
      }
    };

    // 画面遷移時にエラーフラグが立っていた場合は落とす
    this.deleteErrorFlg = () => {
      if ($sessionStorage[Const.SSAPP_HAS_NETWORK_ERROR] !== null) {
        delete $sessionStorage[Const.SSAPP_HAS_NETWORK_ERROR];
      }
      if ($sessionStorage[Const.SSAPP_HAS_REFRESH_OK] !== null) {
        delete $sessionStorage[Const.SSAPP_HAS_REFRESH_OK];
      }
      if ($sessionStorage[Const.SSAPP_HAS_REFRESH_ERROR] !== null) {
        delete $sessionStorage[Const.SSAPP_HAS_REFRESH_ERROR];
      }
      if ($sessionStorage[Const.SSAPP_HAS_UNEXPECTED_ERROR] !== null) {
        delete $sessionStorage[Const.SSAPP_HAS_UNEXPECTED_ERROR];
      }
      if ($sessionStorage[Const.SSAPP_HAS_MAINTENANCE_ERROR] !== null) {
        delete $sessionStorage[Const.SSAPP_HAS_MAINTENANCE_ERROR];
      }
      if ($sessionStorage[Const.SSAPP_IS_LOADING] !== null) {
        delete $sessionStorage[Const.SSAPP_IS_LOADING];
      }
    };

    /*
       禁則文字チェックを行う
       true  : 禁則文字を含む
       false : 禁則文字を含まない
     */
    this.isProhibitionChars = chars => {
      let f = char => {
        let notProhibitionChars =
          [
            'abcdefghijklmnopqrstuvwxyz',
            'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            '0123456789',
            '^$*.[]{}()?-“!@#%&/,><‘:;|_~`'
          ];
        let chars = notProhibitionChars.join('');
        if (~chars.indexOf(char)) {
          return false;
        }
        return true;
      };
      for (let i = 0; i < chars.length; i += 1) {
        if (f(chars.charAt(i))) { return true; }
      }
      return false;
    };

    /*
       パスワードポリシーチェックを行う
       true  : ポリシーに従っている
       false : ポリシーに従っていない
     */
    this.isPasswordPolicy = chars => {
      let chk = {lower: false, upper: false, num: false, symbol: false};
      let notProhibitionChars = this.fullSetList;
      for (let i = 0; i < chars.length; i += 1) {
        for (let v in notProhibitionChars) {
          if (notProhibitionChars[v].indexOf(chars.charAt(i)) < 0) {
            continue;
          }
          switch (v) {
            case '0':
              chk['lower'] = true;
              break;
            case '1':
              chk['upper'] = true;
              break;
            case '2':
              chk['num'] = true;
              break;
            case '3':
              chk['symbol'] = true;
              break;
            default:
              // 処理なし
          }
          // パスワードポリシーの強弱を変えたい場合は、以下の分岐部分で強弱をつける
          // ex): chk['lower'] && chk['upper'] && chk['num'] && chk['symbol']
          //      => アルファベット大文字小文字、数値、記号を含む
          // ex): chk['lower'] && chk['num']
          //      => アルファベット小文字、数値を含む(アルファベット大文字、記号は任意)
          if (chk['lower'] && chk['num']) {
            return true;
          }
        }
      }
      return false;
    };

    this.setStorage = (key, value) => {
      localStorage.setItem(key, value);
      $sessionStorage[key] = value;
    };

    // プログレスバー 表示
    this.overlayShow = () => {
      $sessionStorage[Const.SSAPP_IS_LOADING] = true;
    };

    // プログレスバー 非表示
    this.overlayHidden = () => {
      $sessionStorage[Const.SSAPP_IS_LOADING] = false;
    };

    return this;
  }
]);



// WEBPACK FOOTER //
// ./app/lib/common.es6